export default __webpack_public_path__ + "static/media/intertop_mobile.11e4ebe0.svg";